export function a11yProps(
  name: string,
  index: number
): { id: string; 'aria-controls': string } {
  return {
    id: `${name}-tab-${index}`,
    'aria-controls': `${name}-tabpanel-${index}`
  };
}
